export default "__VITE_ASSET__DYqv1WqS__"